<template>
  <div :id="id" aria-live="assertive">
    <template v-if="validator.$dirty">
      <div v-for="err in validator.$errors" :key="err.$uid" :class="$style.errorLine">
        <slot :name="`err_${err.$validator}`">
          {{ err.$message }}
        </slot>
      </div>
    </template>
  </div>
</template>

<script setup>
  defineProps({
    id: {
      type: String,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.errorLine {
  @include font(500, 14px, 20px);
  padding: 8px 0;
  color: $color-error-v2-text;
}
</style>
